export const company = {
  name: '小智科技',
  fullName: '十堰小智科技有限公司',
  slogan: '智慧政务解决方案提供商',
  description:
    '十堰小智科技有限公司深耕政务信息化与智慧城市领域，以人工智能、大数据、云计算等前沿技术为核心驱动力，为各级政府部门及企事业单位提供智能化、一站式数字治理解决方案，全面助力政务效能提升与治理能力现代化。',
  address: '湖北省十堰市张湾区万达广场C座1201',
  phone: '18311242595',
  phone2: '15071596017',
  email: '352047200@qq.com',
  icp: '鄂ICP备2024036096号-2',
  copyright: '2020-2026'
}

export const navItems = [
  { label: '首页', to: '/' },
  { label: '干部管理', to: '/cadre-management' },
  { label: '智慧党建', to: '/smart-party' },
  { label: '数字乡村', to: '/digital-village' },
  { label: '综合治理', to: '/comprehensive-governance' },
  { label: '智慧巡检', to: '/smart-inspection' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' }
]

export const stats = [
  { value: '20+', label: '政企客户' },
  { value: '99.9%', label: '系统可用性' },
  { value: '7×24', label: '运维保障服务' }
]

export const badges = [
 
  { icon: '👥', title: '20+ 政企客户', desc: '覆盖鄂西北多地区', color: '#fef9e8' },
  { icon: '🏆', title: '5年+ 行业经验', desc: '深耕政务领域', color: '#f3e8fe' },
  { icon: '🌐', title: '10市+ 服务覆盖', desc: '区域广泛覆盖', color: '#e8f4fe' },
  { icon: '🔒', title: '等保测评认证', desc: '安全保障体系', color: '#fee8e8' }
]

export const processSteps = [
  {
    step: '01',
    title: '业务场景共创',
    desc: '与业务处室、信息中心和一线使用人员共同梳理高频事项，明确哪些环节适合智能辅助，哪些环节必须保留人工复核。'
  },
  {
    step: '02',
    title: '数据治理与权限',
    desc: '围绕组织、人事、案件、税务等数据建立目录、标签、脱敏和授权策略，让数据能用、好用，同时不越界。'
  },
  {
    step: '03',
    title: '模型与应用适配',
    desc: '结合知识库、规则引擎、OCR、知识图谱和大模型推理，为不同岗位配置可落地的工作台、驾驶舱和智能助手。'
  },
  {
    step: '04',
    title: '试点验证与推广',
    desc: '先在重点单位或重点业务试点，沉淀指标、模板和培训材料，再逐步扩展到更多处室、区县或下级单位。'
  }
]

export const advantages = [
  {
    icon: '⚙️',
    title: '全栈自研，自主可控',
    desc: '核心算法与平台均为自主研发，非外包集成，拥有30+项软件著作权，确保技术独立与持续迭代能力。'
  },
  {
    icon: '🔐',
    title: '私有化部署，数据不出域',
    desc: '支持全离线私有化部署，敏感数据不经过外部网络，满足政府单位最严格的数据安全与保密要求。'
  },
  {
    icon: '💻',
    title: '国产信创全适配',
    desc: '全面兼容鲲鹏、飞腾处理器，适配麒麟、统信操作系统及达梦、人大金仓等国产数据库，助力信创落地。'
  },
  {
    icon: '📊',
    title: '8年+政务行业深耕',
    desc: '自2018年创立以来专注政务信息化，深入理解组织人事、税务征管、纪检监察等业务场景与审批流程。'
  },
  {
    icon: '🤖',
    title: 'AI能力持续进化',
    desc: '集成大模型推理、知识图谱、OCR识别、自然语言处理等AI技术，并根据客户场景持续训练优化模型效果。'
  },
  {
    icon: '🎯',
    title: '500+项目实战经验',
    desc: '已为湖北省及周边多个地市的政府客户提供成熟方案，从需求调研到运维保障全流程交付，确保项目真正落地见效。'
  }
]

export const products = [
  {
    id: 'gov',
    icon: '👔',
    title: '数字干部管理',
    desc: '干部全生命周期管理平台，涵盖选拔、考核、培养、监督，实现干部管理数字化与智能化',
    color: '#0052d9',
    route: '/cadre-management'
  },
  {
    id: 'party',
    icon: '🚩',
    title: '智慧党建',
    desc: '组织生活、党员发展、党费管理、学习培训全流程数字化，助力基层党组织标准化规范化建设',
    color: '#c8102e',
    route: '/smart-party'
  },
  {
    id: 'village',
    icon: '🌾',
    title: '数字乡村',
    desc: '乡村治理、智慧农业、便民服务、产业振兴全流程数字化，助力乡村振兴战略落地见效',
    color: '#0a6e4e',
    route: '/digital-village'
  },
  {
    id: 'governance',
    icon: '🛡️',
    title: '综合治理',
    desc: '网格化管理、事件处置、矛盾调解、指挥调度一体化平台，提升基层社会治理效能',
    color: '#531dab',
    route: '/comprehensive-governance'
  },
  {
    id: 'inspection',
    icon: '🔍',
    title: '智慧巡检',
    desc: '摄像头+无人机+AI算法+广播驱离，空地协同智能识别，事件调度处置业务闭环',
    color: '#d48806',
    route: '/smart-inspection'
  }
]

export const services = [
  {
    icon: '💡',
    title: '前期咨询',
    desc: '协助梳理现状系统、数据来源、角色权限和业务痛点，形成可执行的建设清单与优先级。'
  },
  {
    icon: '🚀',
    title: '实施交付',
    desc: '按里程碑推进原型确认、环境部署、数据导入、接口联调、试运行和验收准备。'
  },
  {
    icon: '🛡️',
    title: '安全合规',
    desc: '支持私有化部署、国产化环境适配、日志审计、敏感数据脱敏和等保相关整改配合。'
  },
  {
    icon: '🔄',
    title: '持续运营',
    desc: '提供功能迭代、模型优化、使用培训、运行巡检和节假日前重点保障服务。'
  }
]

export const serviceTags = ['驻场/远程联合交付', '专属项目经理', '分级权限设计', '上线培训材料']

export const clients = [
  '十堰市交通运输局', '十堰市委党校', '襄阳市检察院', '宜昌市税务局',
  '十堰市人社局', '荆州市组织部', '恩施州组织部', '黄冈市委组织部',
  '孝感市委组织部', '随州市组织部', '东风汽车集团', '中国航发集团',
  '湖北交投集团', '湖北农商银行', '汉口银行', '湖北汽车工业学院',
  '湖北医药学院', '汉江师范学院', '湖北师范大学', '武汉音乐学院'
]

export const productOptions = [
  '干部管理系统',
  '智慧党建系统',
  '数字乡村系统',
  '综合治理系统',
  '智慧巡检系统',
  'AI办案平台',
  '智慧税务方案',
  'AI基座平台',
  '定制化方案',
  '其他'
]
